import axios from 'axios';
import { SetupApiOptions } from '../../shared/models/setup';
import ErcApiClient from '../../shared/services/erc-api-client';
import { mapAxiosResponse } from '../../shared/utils/api-utils';
import { LoginSuccessResponse } from '../../shared/models/login';
import { ServerError, ServerErrorMessages } from '../../shared/utils/server-error-utils';
import mapResponseOnUserInfo, { UserInfoResponse } from '../../shared/models/user';
import EnvironmentUtils from '../../shared/utils/environment-utils';

const apiEnrouteUrl = EnvironmentUtils.getVar('API_ENROUTE');

export default class SetupService {
  public static async setPassword(options: SetupApiOptions) {
    let loginResponse;
    try {
      loginResponse = await ErcApiClient.post('/login', {
        username: options.username,
        password: process.env.USER_DEFAULT_PASSWORD,
      });
    } catch (err) {
      let errorMessage = ServerErrorMessages[err.message];

      if (!errorMessage) {
        errorMessage = ServerErrorMessages[ServerError.UnexpectedError];
      }

      throw new Error(errorMessage);
    }

    const login = mapAxiosResponse<LoginSuccessResponse>(loginResponse);

    let setPasswordResp;
    try {
      setPasswordResp = await axios.post(`${ apiEnrouteUrl }/agent/self/link_account`, {
        type: 'tracking',
        profile: {
          password: options.password,
        },
      }, {
        headers: {
          Authorization: `Bearer ${ login.enroute_login.access_token }`,
        },
      });
    } catch (err) {
      let errorMessage = ServerErrorMessages[err.message];

      if (!errorMessage) {
        errorMessage = ServerErrorMessages[ServerError.UnexpectedError];
      }

      throw new Error(errorMessage);
    }

    return mapResponseOnUserInfo(mapAxiosResponse<UserInfoResponse>(setPasswordResp));
  }
}